export { default } from './PaymentSchedule';
